<template>
  <div class="audit-index-wrapper">
    <header class="audit-navbar">
      <div class="navbar-container">
        <div class="logo-section" @click="$router.push('/ai')">
          <div class="logo-box">
            <i class="el-icon-cpu"></i> </div>
          <span class="brand-name">AI</span>
        </div>

        <div class="menu-section">
          <el-menu
            :default-active="activePath"
            mode="horizontal"
            router
            class="audit-menu"
          >
            <el-menu-item index="/ai/video">
              <i class="el-icon-video-camera"></i>视频审核
            </el-menu-item>
            <el-menu-item index="/ai/image">
              <i class="el-icon-picture-outline"></i>图像理解
            </el-menu-item>
            <el-menu-item index="/ai/audio">
              <i class="el-icon-mic"></i>音频识别
            </el-menu-item>
            <el-menu-item index="/ai/text">
              <i class="el-icon-document"></i>文本分析
            </el-menu-item>
          </el-menu>
        </div>

        <div class="navbar-right">
          <el-tooltip content="刷新当前页面" placement="bottom">
            <el-button type="text" icon="el-icon-refresh" @click="handleRefresh"></el-button>
          </el-tooltip>
          <el-divider direction="vertical"></el-divider>
          <span class="user-info">Admin</span>
        </div>
      </div>
    </header>

    <main class="audit-content">
      <transition name="fade-transform" mode="out-in">
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </main>
  </div>
</template>

<script>
export default {
  name: 'AuditIndex',
  computed: {
    activePath() {
      // 如果路由是 /ai/video/detail 等，依然高亮 /ai/video
      const pathArr = this.$route.path.split('/');
      if (pathArr.length >= 3) {
        return `/${pathArr[1]}/${pathArr[2]}`;
      }
      return this.$route.path;
    }
  },
  methods: {
    handleRefresh() {
      location.reload();
    }
  }
};
</script>

<style scoped>
/* 容器布局 */
.audit-index-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f0f2f5; /* 略深一点的底色，衬托卡片 */
}

/* 导航栏样式 */
.audit-navbar {
  background-color: #ffffff;
  height: 64px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 0 24px;
}

.navbar-container {
  display: flex;
  align-items: center;
  height: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

/* Logo 样式 */
.logo-section {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 40px;
  transition: opacity 0.3s;
}

.logo-section:hover {
  opacity: 0.8;
}

.logo-box {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #409EFF 0%, #1d42ad 100%);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.logo-box i {
  color: #fff;
  font-size: 20px;
}

.brand-name {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

/* 菜单区域 */
.menu-section {
  flex: 1;
}

.audit-menu {
  border-bottom: none !important;
  height: 64px;
}

/* 覆盖 Element UI 默认样式，让高度对齐 */
.el-menu--horizontal > .el-menu-item {
  height: 64px !important;
  line-height: 64px !important;
  font-size: 15px;
  border-bottom-width: 3px !important;
}

/* 右侧工具栏 */
.navbar-right {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.navbar-right .el-button {
  font-size: 18px;
  color: #606266;
}

.user-info {
  font-size: 14px;
  color: #606266;
  margin-left: 10px;
  font-weight: 500;
}

/* 内容区区域 */
.audit-content {
  flex: 1;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

/* 动画过渡 */
.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}
.fade-transform-enter {
  opacity: 0;
  transform: translateX(-20px);
}
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

/* 响应式适配 */
@media (max-width: 768px) {
  .brand-name {
    display: none; /* 小屏隐藏文字只留 logo */
  }
  .navbar-container {
    padding: 0;
  }
}
</style>
